export default __webpack_public_path__ + "static/media/Leafs.8eb1bc8b.png";